import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadChartListEpic } from './_epics/loadChartList.epic';
import { loadChartMetadataEpic } from './_epics/loadChartMetadata.epic';

export const supersetEpic = safeCombineEpics(
  loadChartListEpic,
  loadChartMetadataEpic,
);
